import {Fragment, ChangeEvent} from 'react';

const Input: (props: any) => JSX.Element = (props: any) => {

    const {attributes, defaultValue, onChange, className} = props;

    const handleChange = (value: ChangeEvent<HTMLInputElement>) => {
        if (onChange && value && value.target) {
            onChange(value.target.value);
        }
    };

    return (
        <Fragment>
            <input type="text" className={`relative z-[99] border-[1px] border-gray-300 w-full rounded-2xl p-3 font-normal text-[1rem]${className ? ` ${className}` : ''}`} {...attributes} value={defaultValue} onChange={(p: ChangeEvent<HTMLInputElement>) => handleChange(p)} />
        </Fragment>
    );
}

export default Input;
